export const MODAL_CONFIRM_BUTTON_LABEL = "übernehmen";
export const BASE_ASSET_URL = " https://esr.fe-bis.de/de/hagebau/"
